<template>
  <div>
    <div class="flex-1 flex justify-between sm:hidden">
      <button :disabled="!hasPrev" @click="clickPrev" :class="buttonClass(false,hasPrev)" class="rounded-md">
        Previous
      </button>
      <button :disabled="!hasNext" @click="clickNext" :class="buttonClass(false,hasNext)" class="rounded-md">
        Next
      </button>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm leading-5 text-gray-700">
          <slot name="position"></slot>
        </p>
      </div>
      <div>
        <div class="relative z-0 inline-flex">
          <button v-if="hasFirstButton" @click="setPage(1)" :class="buttonClass(false, true)" class="rounded-l-md">
            1
          </button>
          <button v-if="hasFirstEllipse" :class="buttonClass(false, false, true)" class="-ml-px" disabled>
            ...
          </button>
          <button v-for="(page,index) in pagesInRange" @click="setPage(page)" class="-ml-px"
                  :class="buttonClass(page===currentPage,true) + ((!hasFirstButton&&index==0) ? ' rounded-l-md' : '')">
            {{ page }}
          </button>
          <button v-if="hasLastEllipse" :class="buttonClass(false, false, true)" class="-ml-px" disabled>
            ...
          </button>
          <button v-if="hasLastButton" @click="setPage(pageCount)" :class="buttonClass(false, true)" class="-ml-px">
            {{ pageCount }}
          </button>
          <button :disabled="!hasPrev" @click="clickPrev" :class="buttonClass(false,hasPrev,false,true)"
                  class="-ml-px bg-white">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"/>
            </svg>
          </button>
          <button :disabled="!hasNext" @click="clickNext" :class="buttonClass(false,hasNext)"
                  class="-ml-px bg-white rounded-r-md">
            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: "pagination",
    props: {
        current: {type: Number, default: 1},
        perPage: {type: Number, default: 10},
        total: {type: Number, default: 0}
    },
    data() {
        return {currentPage: this.current};
    },
    watch: {
        current() {
            this.currentPage = this.current;
        }
    },
    computed: {
        hasFirstButton() {
            return this.currentPage >= 3;
        },
        hasFirstEllipse() {
            return this.currentPage >= 4;
        },
        hasLastButton() {
            return this.currentPage <= this.pageCount - 2;
        },
        hasLastEllipse() {
            return this.currentPage <= this.pageCount - 3;
        },
        hasPrev() {
            return this.currentPage > 1;
        },
        hasNext() {
            return this.currentPage < this.pageCount;
        },
        pageCount() {
            return Math.ceil(this.total / this.perPage);
        },
        /**
         * Get near pages, 1 before and 1 after the current.
         * Also add the click event to the array.
         */
        pagesInRange() {
            const left = Math.max(1, this.currentPage - 1);
            const right = Math.min(this.currentPage + 1, this.pageCount);
            const pages = [];
            for (let i = left; i <= right; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        buttonClass(current, active, ellipse, leftButton) {
            let classes = "relative inline-flex items-center py-2 border border-gray-300 text-sm leading-5 focus:outline-none focus:ring-blue focus:border-blue-300 transition ease-in-out duration-150";
            if (current) {
                return classes + ' font-semibold bg-indigo-100 text-indigo-700 z-1 px-4 hover:bg-indigo-50 active:bg-indigo-200';
            }
            if (ellipse) {
                return classes + ' font-normal bg-white text-gray-500 px-2 cursor-not-allowed';
            }
            if (active) {
                return classes + ' font-medium bg-white text-gray-700 px-4 hover:text-gray-500 active:bg-gray-50 active:text-gray-800';
            }
            classes += ' font-medium bg-gray-100 text-gray-500 px-4 cursor-not-allowed';
            if (leftButton && this.total === 0) {
                classes += ' rounded-l-md';
            }
            return classes;
        },
        clickNext() {
            this.setPage(this.currentPage + 1);
        },
        clickPrev() {
            this.setPage(this.currentPage - 1);
        },
        setPage(page) {
            this.currentPage = page;
            this.$emit('set-page', page);
        }
    }
}
</script>
